import { Box, Text, TextButton } from '@wix/design-system';
import { CycleUtils } from '@wix/package-picker-shared';
import React, { useEffect } from 'react';
import { ECLIPSE_SALE_TEXT_COLOR } from '../../../utils';
import { useCurrentModule } from '../../ModuleProvider';
import { cycleSlug, getHigherCycleCopyKeys } from './upsellCopyKeys';
import { resolveBadgeSavingsAmount, resolveComparisonPrice } from './upsellPricing';
import s from './SwitchToHigherCycle.scss';
const BORDER_COLOR = '#CFD1DC';
export function SwitchToHigherCycle(_ref) {
  var _targetPricing$monthl;
  let {
    targetPricing,
    items,
    onSwitchCycle
  } = _ref;
  const module = useCurrentModule();
  const selectedCycle = module.SDK.PackagePickerStore.useSelectedCycle();
  const {
    t,
    Trans
  } = module.internals.useTranslations();
  const targetCycleId = targetPricing.cycleId;
  const componentName = `switch to ${cycleSlug(targetPricing.cycle)}`;
  const {
    titleKey,
    ctaKey
  } = getHigherCycleCopyKeys(targetPricing.cycle);
  useEffect(() => {
    module.internals.bi.onSwitchCycleComponentLoad == null || module.internals.bi.onSwitchCycleComponentLoad({
      componentName,
      targetCycle: targetCycleId
    });
  }, [module, componentName, targetCycleId]);
  const currentCycleId = selectedCycle ? CycleUtils.convertCycleToCycleId(selectedCycle) : undefined;
  const currentPricing = items.find(item => item.cycleId === currentCycleId);
  const getBadgeText = () => {
    const savingsAmount = resolveBadgeSavingsAmount(targetPricing.savings);
    if (!savingsAmount) {
      return null;
    }
    return t('checkout.summary.yearly_upsell.savings_badge.label', {
      savingsAmount
    });
  };
  const newPrice = (_targetPricing$monthl = targetPricing.monthlyFinalPrice) == null ? void 0 : _targetPricing$monthl.formattedAmount;
  const oldPrice = resolveComparisonPrice(items, currentPricing);
  const badgeText = getBadgeText();
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    padding: "SP3",
    border: `1px solid ${BORDER_COLOR}`,
    borderRadius: "8px",
    marginTop: "SP3",
    marginBottom: "SP3",
    width: "100%",
    boxSizing: "border-box",
    gap: "SP1"
  }, badgeText && /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "bold"
  }, /*#__PURE__*/React.createElement("span", {
    className: s.savingsBadge,
    style: {
      color: ECLIPSE_SALE_TEXT_COLOR
    }
  }, badgeText)), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "normal",
    className: s.upsellTitle
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: titleKey,
    values: {
      newPrice,
      oldPrice
    },
    components: {
      cycle: /*#__PURE__*/React.createElement("span", {
        className: s.cycleName
      })
    }
  })), /*#__PURE__*/React.createElement(TextButton, {
    size: "small",
    weight: "bold",
    onClick: () => {
      module.internals.bi.onSwitchCycleComponentClick == null || module.internals.bi.onSwitchCycleComponentClick({
        targetCycle: targetCycleId,
        componentName
      });
      onSwitchCycle(targetCycleId);
    }
  }, t(ctaKey)));
}
//# sourceMappingURL=SwitchToHigherCycle.js.map